import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialogs-empty" }
const _hoisted_2 = { class: "dialogs-empty__content" }
const _hoisted_3 = { class: "dialogs-empty__title" }
const _hoisted_4 = { class: "dialogs-empty__text" }

import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatDialogsEmpty',
  emits: ["on-create"],
  setup(__props, { emit: __emit }) {

const emit = __emit


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppIcon, {
          name: "comment-success",
          size: "20px",
          color: "#979797"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('chat_empty_title')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('chat_empty_description')), 1),
      _createVNode(AppButton, {
        type: "secondary",
        label: _ctx.$t('chat_create_new'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('on-create')))
      }, null, 8, ["label"])
    ])
  ]))
}
}

})